<div class="topline">
  <h1>Clients</h1>

  @if (noPartner && !isClientAdministrator) {
    <app-inlinemessage level="warning" message="No Partner Brand Set for Client"></app-inlinemessage>
  }

  <div class="clientarea">
    @if (!isClientAdministrator) {
      <mat-menu #menu="matMenu">
        <ng-template matMenuContent let-item="item">
          <button mat-menu-item (click)="editCompany()">Edit</button>
          <button
            mat-menu-item
            (click)="togglePayrollTeamPlusDefault()"
            [matTooltip]="plusPlanDefaultHelpText">
            {{ getPayrollTeamPlusDefaultActionLabel() }}
          </button>
          <button
            mat-menu-item
            (click)="toggleIncludedPlusPlan()"
            [matTooltip]="includedPlusPlanHelpText">
            {{ getIncludedPlusPlanActionLabel() }}
          </button>
        </ng-template>
      </mat-menu>
      <mat-icon [matMenuTriggerFor]="menu">settings</mat-icon>
    }

    @if (clients.length > 0) {
      <mat-form-field>
        <mat-label>Current Client</mat-label>
        <mat-select
          [(value)]="selectedClientId"
          (selectionChange)="setClientId($event.value)">
          @for (client of clients; track client) {
            <mat-option [value]="client.id">
              {{ client.name }} ({{ clientCensusCounts[client.id] || 0 }})
            </mat-option>
          }
        </mat-select>
      </mat-form-field>
    }
  </div>

  @if (clients?.length === 0) {
    <h1>
      {{ clientName }}
    </h1>
  }
</div>

<app-infoband [items]="info"></app-infoband>

<nav mat-tab-nav-bar [tabPanel]="tabs">
  @for (link of links; track link) {
    <a
      mat-tab-link
      (click)="gotoTab(link)"
      [active]="activeLink?.title === link.title">
      {{ link.title }}
    </a>
  }
</nav>

@if (!selectedClientId) {
  <app-inlinemessage
    level="info"
    message="Please select a client so that you can manage their census, eligibility, and enrollment">
  </app-inlinemessage>
}

@if (selectedClientId) {
  @if (activeLink?.title === 'Census') {
    <app-client-census
      [clientAdministrator]="isClientAdministrator"
      [clientId]="selectedClientId">
    </app-client-census>
  }
  @if (activeLink?.title === 'Eligibility') {
    <app-client-eligibility
      [clientAdministrator]="isClientAdministrator"
      [clientId]="selectedClientId">
    </app-client-eligibility>
  }
  @if (activeLink?.title === 'Enrollment') {
    <app-client-enrollment
      [clientId]="selectedClientId">
    </app-client-enrollment>
  }
}

<mat-tab-nav-panel #tabs></mat-tab-nav-panel>
